/**
 * RendererRegistry — Singleton registry for domain scene classes.
 *
 * Domain scene modules self-register on import. The RenderRouter and
 * PhaserGame query the registry at render time so adding a new domain
 * never requires editing core engine files.
 *
 * Usage:
 *   // In FootballScene.js (bottom of file):
 *   RendererRegistry.register('football', FootballScene, 'phaser_2d');
 *
 *   // In RenderRouter.js:
 *   const SceneClass = RendererRegistry.getScene(rendererKey);
 *
 * The two-level dispatch:
 *   scene_type  → selects rendering engine (phaser_2d, content_panel, ...)
 *   renderer_key → selects domain scene class within that engine
 */

import BaseGameScene from './scenes/BaseGameScene';

const _entries = {};

const RendererRegistry = {
  register(rendererKey, SceneClass, sceneType = 'phaser_2d') {
    _entries[rendererKey] = { SceneClass, sceneType };
    return RendererRegistry;
  },

  getScene(rendererKey) {
    const entry = _entries[rendererKey];
    return entry?.SceneClass || BaseGameScene;
  },

  getSceneType(rendererKey) {
    const entry = _entries[rendererKey];
    return entry?.sceneType || 'content_panel';
  },

  has(rendererKey) {
    return rendererKey in _entries;
  },

  listRegistered() {
    return Object.keys(_entries);
  },
};

RendererRegistry.register('base', BaseGameScene, 'phaser_2d');

export default RendererRegistry;
